export default __webpack_public_path__ + "static/media/marker_orange.23c6f5d3.png";